import { render } from "./SaveQualificationEducation.vue?vue&type=template&id=42c14800"
import script from "./SaveQualificationEducation.vue?vue&type=script&lang=js"
export * from "./SaveQualificationEducation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__